import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { PopupModal } from '@/components/common/Modal'
import * as dateutil from '@/util/date-helper'
@Component({
    components: {
        PopupModal
    }
})
export default class EndTimeModal extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Boolean, default: false }) show!: boolean

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    timeArray: Array<any> = []

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    get TimeArray() {
        this.timeArray.sort((a, b) => a.num - b.num);
        return this.timeArray;
    }

    set TimeArray(value) {
        this.timeArray = value;
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.timeArray = dateutil.uGetTimeArray([this.$t('W_AM').toString(), this.$t('W_PM').toString()])
    }
}
